export default "__VITE_ASSET__xdNPEsZU__"